// Wrap the code in an IIFE so that it attaches correctly to window.
(function() {
  /**
   * Initialize the product media gallery within a given context.
   * @param {HTMLElement} context - The parent element for the gallery (defaults to document)
   * @returns {Object|null} - Returns an object with references to mainSwiper and thumbnailSwiper, or null if not found.
   */
  function initProductMediaGallery(context) {
    context = context || document;
    const thumbnailContainer = context.querySelector('.thumbnail-container');
    const mainImageContainer = context.querySelector('.main-image-container');
    if (!thumbnailContainer || !mainImageContainer) return null;

    // Function to set equal heights (only for screens 750px and above)
    function setEqualHeights() {
      if (!thumbnailContainer || !mainImageContainer) return;
      if (window.innerWidth < 750) {
        thumbnailContainer.style.removeProperty('height');
        mainImageContainer.style.removeProperty('height');
        return;
      }
      const containerWidth = mainImageContainer.offsetWidth;
      const desiredHeight = Math.min(window.innerHeight * 0.7, containerWidth);
      thumbnailContainer.style.height = `${desiredHeight}px`;
      mainImageContainer.style.height = `${desiredHeight}px`;
    }

    setEqualHeights();
    window.addEventListener('resize', setEqualHeights);
    window.addEventListener('orientationchange', setEqualHeights);

    function getInitialSlide() {
      const galleryEl = context.querySelector('.new-gallery');
      const requestedSlide = galleryEl ? Number(galleryEl.dataset.initialSlide) : Number(window.selectedVariantImageIndex);
      const slideCount = context.querySelectorAll('.main-swiper .swiper-slide').length;
      if (!Number.isFinite(requestedSlide) || requestedSlide < 0 || requestedSlide >= slideCount) return 0;
      return requestedSlide;
    }

    const initialSlide = getInitialSlide();

    // Initialize the thumbnail Swiper.
    const thumbnailSwiperEl = context.querySelector(".thumbnail-swiper");
    let thumbnailSwiper = null;
    if (thumbnailSwiperEl) {
      thumbnailSwiper = new Swiper(thumbnailSwiperEl, {
        direction: "horizontal",
        breakpoints: {
          769: { direction: "vertical" }
        },
        slidesPerView: "auto",
        spaceBetween: 10,
        watchSlidesProgress: true,
        mousewheel: true,
        initialSlide: initialSlide, // Start at the selected variant's image
        navigation: {
          nextEl: context.querySelector(".thumbnail-next"),
          prevEl: context.querySelector(".thumbnail-prev")
        },
        on: {
          init: function() {
            setTimeout(() => {
              const thumbCont = context.querySelector('.thumbnail-container');
              if (thumbCont) {
                thumbCont.classList.add('thumbnail-container--gradient');
              }
            }, 300);
          },
          reachEnd: function() {
            const thumbCont = context.querySelector('.thumbnail-container');
            if (thumbCont) {
              thumbCont.classList.remove('thumbnail-container--gradient');
            }
          },
          fromEdge: function() {
            const thumbCont = context.querySelector('.thumbnail-container');
            if (thumbCont) {
              thumbCont.classList.add('thumbnail-container--gradient');
            }
          }
        }
      });
    }

    // Initialize the main image Swiper.
    const mainSwiperEl = context.querySelector(".main-swiper");
    let mainSwiper = null;
    if (mainSwiperEl) {
      mainSwiper = new Swiper(mainSwiperEl, {
        spaceBetween: 10,
        initialSlide: initialSlide, // Start at the selected variant's image
        navigation: {
          nextEl: context.querySelector(".nav-button-next"),
          prevEl: context.querySelector(".nav-button-prev")
        },
        thumbs: {
          swiper: thumbnailSwiper
        },
        lazy: {
          loadPrevNext: true,
        }
      });
    }

    if (mainSwiper && initialSlide > 0) {
      requestAnimationFrame(() => {
        if (!window.EG_PDP_VARIANT_INTERACTED && mainSwiper.slides.length > initialSlide) {
          mainSwiper.slideTo(initialSlide, 0, false);
          if (thumbnailSwiper) thumbnailSwiper.slideTo(initialSlide, 0, false);
        }
      });
    }

    // Make thumbnails clickable to control the main swiper.
    context.querySelectorAll(".thumbnail-swiper .swiper-slide").forEach((slide, index) => {
      slide.addEventListener("click", () => {
        if (mainSwiper) mainSwiper.slideTo(index);
        if (window.innerWidth >= 769) {
          thumbnailSwiper.el.scrollTop = slide.offsetTop - 100;
        } else {
          thumbnailSwiper.el.scrollLeft = slide.offsetLeft - 50;
        }
      });
    });

    return { mainSwiper, thumbnailSwiper };
  }

  // Expose the initializer function to the global window object.
  window.initProductMediaGallery = initProductMediaGallery;

  // On initial page load (for content already in the document), initialize the gallery.
  document.addEventListener("DOMContentLoaded", function () {
    window.currentProductMediaGallery = window.initProductMediaGallery(document);
  });
})();

// Variant change subscription: wait for shopper interaction before syncing gallery to variant imagery.
subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
  if (!window.EG_PDP_VARIANT_INTERACTED) return;

  const variant = event.data.variant;
  if (!variant) return;

  // Use the modal if open, otherwise the document.
  var context = document.querySelector('#product-options-modal') || document;
  const images = context.querySelectorAll(".main-swiper .swiper-slide > img[data-media-id]");
  let targetIndex = null;
  
  // Method 1 - Try to match by variant's featured_image first using Shopify's native variant featured image functionality
  if (variant.featured_image && variant.featured_image.src) {
    const variantImageSrc = variant.featured_image.src;
    const variantImageFilename = variantImageSrc.split('/').pop().split('?')[0];
    
    images.forEach((img, index) => {
      if (img.src) {
        const imgFilename = img.src.split('/').pop().split('?')[0];
        if (imgFilename === variantImageFilename) {
          targetIndex = index;
          return;
        }
      }
    });
  }

  // Method 2 - Fallback to original color-based logic if no featured image match
  if (targetIndex === null) {
    // Use the global colorIndex from Liquid (or default to 1).
    var colorIndex = window.colorIndex || 1;
    const variantColor = variant["option" + colorIndex];
    if (variantColor) {

      images.forEach((img, index) => {
        const imageColors = img.getAttribute("data-variants");
        if (!imageColors) return;
        
        // Split the comma-separated list of colors and check each one
        const colorsList = imageColors.split(',').map(color => color.trim().toLowerCase());
        
        if (colorsList.includes(variantColor.toLowerCase())) {
          // Use the first matching image
          if (targetIndex === null) {
            targetIndex = index;
          }
        }
      });
    }
  }

  if (targetIndex !== null && window.currentProductMediaGallery && window.currentProductMediaGallery.mainSwiper) {
    window.currentProductMediaGallery.mainSwiper.slideTo(targetIndex);
    if (window.currentProductMediaGallery.thumbnailSwiper) {
      window.currentProductMediaGallery.thumbnailSwiper.slideTo(targetIndex);
    }
  } else {
    // console.log('No matching image found for variant:', variant);
  }
});
